/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Certification } from '../shared/models';

const STATUS_SORT_ORDER: Record<string, number> = {
  'in-progress': 0,
  'in-redo': 1,
  available: 2,
  locked: 3,
  completed: 4,
};

@Injectable({ providedIn: 'root' })
export class AcademyCertificationsService {
  constructor(private http: HttpClient) {}

  getCertification(id: number): Observable<Certification | null> {
    return this.getCertifications().pipe(
      map(certs => certs.find(c => c.id === id) ?? null),
    );
  }

  getCertifications(): Observable<Certification[]> {
    return this.http.get<Certification[]>('/api/v1/certifications').pipe(
      map(certs => [...certs].sort((a, b) => {
        const statusDiff = (STATUS_SORT_ORDER[a.status] ?? 99) - (STATUS_SORT_ORDER[b.status] ?? 99);
        if (statusDiff !== 0) return statusDiff;

        const levelDiff = (a.academy_level ?? 99) - (b.academy_level ?? 99);
        if (levelDiff !== 0) return levelDiff;

        return a.name.localeCompare(b.name);
      })),
      catchError(err => {
        console.error('Failed to load certifications', err);
        return of([]);
      }),
    );
  }
}
